// eslint-disable-next-line import/prefer-default-export
export const REQUEST_QUOTATION = 'quotation?hash/REQUEST_QUOTATION';
